import styled, { css } from 'styled-components'
import { useField } from 'formik'

import { Wrapper, Radio } from '@farewill/ui'
import { GTR, COLOR } from '@farewill/ui/tokens'
import ConditionalWrapper from 'components/conditional-wrapper'
import Tooltip from 'components/tooltip'

const StyledRadio = styled(Radio)`
  margin: 0;

  /* @farewill/ui always shows a filled grey dot and a pointer cursor for a
     disabled radio, even when unchecked — this should look and behave empty. */
  ${({ disabled }) =>
    disabled &&
    css`
      input:not(:checked) + span {
        color: ${COLOR.WHITE} !important;
      }

      input,
      label {
        cursor: not-allowed !important;
      }
    `}
`

const StyledIndentedContent = styled(Wrapper)`
  margin-left: calc(${GTR.M} / 2);
  border-left: ${GTR.XXS} solid ${COLOR.GREY.LIGHT};
`

const IndentedRadio = ({
  value,
  radioValue,
  name,
  label,
  indentedContent,
  disabled = false,
  disabledTooltipContent,
}) => {
  const [field] = useField({ name, type: 'radio', value: radioValue })

  return (
    <Wrapper key={radioValue} margin={['S', 0]}>
      <ConditionalWrapper
        showWrapper={disabled && !!disabledTooltipContent}
        wrapper={(children) => (
          <Tooltip content={disabledTooltipContent} underlined={false}>
            {children}
          </Tooltip>
        )}
      >
        <StyledRadio
          checked={value === radioValue}
          label={label}
          size="M"
          disabled={disabled}
          {...field}
        />
      </ConditionalWrapper>

      {value === radioValue && indentedContent && (
        <StyledIndentedContent
          margin={['XS', 0, 0]}
          padding={['XXS', 0, 'XXS', 'XS']}
        >
          {indentedContent}
        </StyledIndentedContent>
      )}
    </Wrapper>
  )
}

const IndentedRadioGroup = ({ name, options }) => {
  const [field] = useField(name)
  return (
    <Wrapper>
      {options.map(
        ({
          value: radioValue,
          label,
          indentedContent,
          isOptionDisabled,
          disabledTooltipContent,
        }) => {
          return (
            <IndentedRadio
              value={field.value}
              name={name}
              label={label}
              indentedContent={indentedContent}
              radioValue={radioValue}
              disabled={isOptionDisabled}
              disabledTooltipContent={disabledTooltipContent}
              key={radioValue}
            />
          )
        }
      )}
    </Wrapper>
  )
}

export default IndentedRadioGroup
